import EditShareableLinkProvider from './EditShareableLink.provider';

export default EditShareableLinkProvider;